/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectChangeOrderCommandResult } from '../../models/approve-project-change-order-command-result';

export interface ApiProjectChangeOrderApproveProjectChangeOrderPost$Params {
      body?: {
'ApprovedDate': string;
'Id'?: string;
}
}

export function apiProjectChangeOrderApproveProjectChangeOrderPost(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderApproveProjectChangeOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectChangeOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderApproveProjectChangeOrderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectChangeOrderCommandResult>;
    })
  );
}

apiProjectChangeOrderApproveProjectChangeOrderPost.PATH = '/api/ProjectChangeOrder/ApproveProjectChangeOrder';
